<template>
  <section class="container">
    <div class="row mb-5">
      <div class="col-8 offset-2 text-center">
        <h1> Tous vos contrats </h1>
      </div>
      <div
        v-if="contracts.length > 0"
        class="col-2"
      >
        <div class="d-flex flex-column">
          <div
            class="d-flex ms-auto my-auto bg-blue-700 rounded-circle"
            style="width:42px; height: 42px"
          >
            <font-awesome-icon
              icon="filter"
              style="width:19px; height: 19px"
              class="cursor-pointer text-white m-auto"
              @click="openFilter"
            />
          </div>
          <div class="d-none d-md-flex mt-2 ms-auto fw-bold text-blue-700">
            Filtres
          </div>
        </div>
      </div>
      <v-filter-modal
        v-if="isModalOpen"
        :filters="filters"
        @update:filter="updateBadgeInFilter"
        @reset-filter="resetFilter"
        @apply-filter="applyFilterOnContracts"
        @close-filter="closeFilter"
      />
    </div>
    <div
      v-if="contracts.length > 0"
      class="row"
    >
      <div class="col-12">
        <v-contract-display
          v-for="subscription in contractsContainer"
          :key="subscription.id"
          :subscription="subscription"
          class="mb-2"
        />
      </div>
      <div class="col-12 d-flex flex-column my-2">
        <div class="d-flex mx-auto">
          <a
            :href="getAppUrl()"
            class="btn btn-primary"
            style="min-width: 345px"
          >
            <div class="d-flex flex-row justify-content-center">
              <div class="me-1 lead text-white fw-bold">
                Ajouter un contrat
              </div>
              <v-icon icon="plus-white" />
            </div>
          </a>
        </div>
        <div class="d-flex mx-auto mt-1">
          <a
            href="/odr"
            class="btn btn-blue-400"
            style="min-width: 345px"
          >
            <div class="d-flex flex-row justify-content-center">
              <div class="me-1 text-white lead fw-bold">
                Rapatrier un contrat
              </div>
              <v-icon icon="fly-paper-white" />
            </div>
          </a>
        </div>
      </div>
    </div>
    <v-no-resource v-else>
      <div class="d-flex flex-column">
        <div class="lead">
          Vous n’avez pas encore de contrat chez nous !
        </div>
        <div class="mt-2">
          <a
            :href="getAppUrl()"
            class="btn btn-primary fw-bold fs-5"
          >
            Ajouter un nouveau contrat
          </a>
        </div>
      </div>
    </v-no-resource>
  </section>
</template>

<script>
import { mapGetters } from 'vuex';
import { uniq } from 'lodash-es';

import NoResource from '@/components/common/layout/DashboardNoResource.vue';
import ContractDisplay from '@/components/contracts/helpers/ContractDisplay.vue';
import FiltersModal from '@/components/common/filters/FiltersModal.vue';

export default {
  name: 'ContractsView',
  components: {
    'v-no-resource': NoResource,
    'v-filter-modal': FiltersModal,
    'v-contract-display': ContractDisplay,
  },
  data() {
    return {
      filters: [],
      contractsContainer: [],
      statusList: [
        { key: 'ACTIVE', name: 'Actif', color: 'green-300' },
        {
          key: 'EXPIRED', name: 'Résilié', color: 'pink-700', isWhite: true,
        },
        { key: 'SUSPENDED', name: 'Suspendu', color: 'gray-300' },
        {
          key: 'CANCELLED', name: 'Résilié', color: 'pink-700', isWhite: true,
        },
      ],
      productsColor: {
        1: 'blue-500',
        2: 'pink-400',
        4: 'yellow-400',
        5: 'green-400',
        9: 'blue-300',
        13: 'pink-300',
        16: 'yellow-400',
        18: 'green-300',
        19: 'blue-300',
        29: 'yellow-300',
      },
      productsIsWhite: {
        1: true,
        2: true,
        4: false,
        5: false,
        9: false,
        13: false,
        16: false,
        18: false,
        19: false,
        29: false,
      },
    };
  },
  computed: {
    ...mapGetters({
      contracts: 'contracts/get',
      products: 'rater/products',
      isModalOpen: 'ui/focusScreen',
    }),
    allStatus() {
      return uniq(this.contracts.map(({ status }) => status));
    },
    allProducts() {
      return uniq(this.contracts.map(({ productId }) => productId));
    },
    contractFilters() {
      return [{
        title: 'Type de contrat',
        badges: this.allProducts.map(this.buildProductBadges),
      },
      {
        title: 'Status',
        badges: this.allStatus.map(this.buildStatusBadges),
      }];
    },
  },
  watch: {
    allProducts: {
      handler() {
        this.filters = [{
          title: 'Type de contrat',
          badges: this.allProducts.map(this.buildProductBadges),
        },
        {
          title: 'Statut',
          badges: this.allStatus.map(this.buildStatusBadges),
        },
        ];
        this.applyFilterOnContracts();
      },
      deep: true,
      immediate: true,
    },
  },
  beforeMount() {
    this.$store.dispatch('orders/setOrders');
  },
  beforeUnmount() {
    this.$store.dispatch('ui/focusScreen', false);
  },
  mounted() {
    this.applyFilterOnContracts();
  },
  methods: {
    getAppUrl() {
      return import.meta.env.VITE_WIDGET_URL;
    },
    // Switch view of filter
    openFilter() {
      this.$store.dispatch('ui/focusScreen', true);
    },
    closeFilter() {
      this.$store.dispatch('ui/focusScreen', false);
    },
    resetFilter() {
      this.filters = [{
        title: 'Type de contrat',
        badges: this.allProducts.map(this.buildProductBadges),
      },
      {
        title: 'Statut',
        badges: this.allStatus.map(this.buildStatusBadges),
      }];
    },
    // builder for badges
    buildProductBadges(productId) {
      const { name } = (this.products.find(({ id: elemId }) => elemId === productId) || { name: '' });
      return {
        name,
        key: productId,
        active: true,
        color: this.productsColor[productId],
        isWhite: this.productsIsWhite[productId],
      };
    },
    buildStatusBadges(statusKey) {
      const {
        name, key, color, isWhite,
      } = (this.statusList
        .find(({ key: listKey }) => listKey === statusKey)
        || { name: '', key: statusKey, color: 'yellow-400' });
      // eslint-disable-next-line object-curly-newline
      return { name, key, color, active: statusKey === 'ACTIVE', isWhite };
    },

    // Set badge active
    updateBadgeInFilter({ filterIndex, index }) {
      const isActive = this.filters[filterIndex].badges[index].active;
      this.filters[filterIndex].badges[index].active = !isActive;
    },

    filterByType({ productId }) {
      const actives = this.filters[0].badges
        .filter(({ active }) => active)
        .map(({ key }) => key);
      if (actives.length === 0) return true;
      return actives.includes(productId);
    },
    filterByStatus({ status }) {
      const actives = this.filters[1].badges
        .filter(({ active }) => active)
        .map(({ key }) => key);
      if (actives.length === 0) return true;
      return actives.includes(status);
    },

    applyFilterOnContracts() {
      this.contractsContainer = this.contracts
        .filter(({ parentId }) => !parentId)
        .filter(({ status }) => status !== 'QUOTED')
        .filter(this.filterByStatus)
        .filter(this.filterByType);
      this.contractsContainer.sort(this.sortByDate);
      this.closeFilter();
    },

    // Sorting Asc/Desc
    sortByDate({ effectiveDate: a }, { effectiveDate: b }) {
      const aFullYear = (new Date(a)).getFullYear();
      const bFullYear = (new Date(b)).getFullYear();
      return (bFullYear - aFullYear);
    },
  },
};
</script>
